import { useSelector } from 'react-redux'

import Toast from '@/components/Toast'
import {
  hasToastFlashMessagesSelector,
  toastFlashMessagesSelector
} from '@/selectors'

const Toasts = () => {
  const toasts = useSelector(toastFlashMessagesSelector)
  const isShowing = useSelector(hasToastFlashMessagesSelector)

  return (
    <If condition={isShowing}>
      <div className='toast-wrap'>
        {
          toasts.map(({ text, type }, key) => {
            return <Toast key={key} text={text} type={type} />
          })
        }
      </div>
    </If>
  )
}

export default Toasts
